(function () {
    'use strict';

    angular.module("imApp").factory("serviceObjectsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1732,
                    parameters: parms || {}
                });
            },
            listServiceObjects: function (parms) {
                return $ihttp.post({
                    method: 1733,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
